var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconSubscribeComponent(props, ref) {
    var prefixFromContext = useContext(Context).prefix;
    var _a = props.className, className = _a === void 0 ? '' : _a, prefixFromProps = props.prefix, _b = props.width, width = _b === void 0 ? '1em' : _b, _c = props.height, height = _c === void 0 ? '1em' : _c, _d = props.useCurrentColor, useCurrentColor = _d === void 0 ? true : _d, spin = props.spin, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor", "spin"]);
    var prefix = prefixFromProps || prefixFromContext || 'arco';
    var loadingKls = spin ? " ".concat(prefix, "-icon-loading") : '';
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-subscribe").concat(loadingKls, " ").concat(className), width: width, height: height, viewBox: "0 0 16 16", fill: useCurrentColor ? 'currentColor' : '#000', xmlns: "http://www.w3.org/2000/svg" }, rest, { ref: ref }),
        React.createElement("path", { d: "M11.6667 2.69979H4.33341C4.14932 2.69979 4.00008 2.84903 4.00008 3.03312V12.5652L6.94909 10.1691C7.56143 9.67157 8.43873 9.67156 9.05107 10.1691L12.0001 12.5652V3.03312C12.0001 2.84903 11.8508 2.69979 11.6667 2.69979ZM4.33341 1.36646H11.6667C12.5872 1.36646 13.3334 2.11265 13.3334 3.03312V13.9658C13.3334 14.5272 12.682 14.8372 12.2464 14.4832L8.21028 11.2039C8.08781 11.1044 7.91235 11.1044 7.78988 11.2039L3.75381 14.4832C3.31813 14.8372 2.66675 14.5272 2.66675 13.9658V3.03312C2.66675 2.11265 3.41294 1.36646 4.33341 1.36646Z", fillOpacity: "1" }));
}
var IconSubscribe = React.forwardRef(IconSubscribeComponent);
export default IconSubscribe;
